/// <reference path="../../_ext/Editors/MFGTransItemEditorDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkSettlementDetailsDialog extends _Ext.MFGTransItemEditorDialog<JobWorkSettlementDetailsRow> {
        protected getFormKey() { return JobWorkSettlementDetailsForm.formKey; }
        protected getIdProperty() { return JobWorkSettlementDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkSettlementDetailsRow.localTextPrefix; }
        protected getService() { return JobWorkSettlementDetailsService.baseUrl; }
        protected getDeletePermission() { return JobWorkSettlementDetailsRow.deletePermission; }
        protected getInsertPermission() { return JobWorkSettlementDetailsRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkSettlementDetailsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new JobWorkSettlementDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.KnockOff);
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.Rate);
            q.setTextRightAlign(this.form.PureWeight);
            this.form.ProductId.changeSelect2(e => {
                var productid = this.form.ProductId.value;
                if (productid != null) {
                    let product: OMS.RawMaterialMasterRow;
                    OMS.RawMaterialMasterService.Retrieve({ EntityId: productid }
                        , response => {
                            product = response.Entity;
                            this.form.PureWeight.value = this.form.KnockOff.value / product.Purity;
                        }, { async: false })
                }
            });
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            var type = (this.parentEditor as JobWorkSettlementDetailsEditor).type;
            var masterform = (this.parentEditor.parentDialog as JobWorkSettlementDialog).form;
            this.entity.ProductTypeId = parseInt(masterform.ProductTypeId.value);
            this.entity.Type = type;
            var producttype = OMS.ProductTypeRow.getLookup().itemById[masterform.ProductTypeId.value].ProductTypeCode;
            this.form.ProductTypeCode.value = producttype;
            this.form.KnockOff.value = masterform.KnockOff.value;
            if (type == "Metal") {
                q.showField(this.form.ProductId);
                q.hideField(this.form.Rate);
                q.hideField(this.form.Amount);
            }
            else {
                q.hideField(this.form.ProductId);

                if (this.form.Rate.value == null || this.form.Rate.value == 0) {
                    OMS.MetalRateMasterService.GetMetalRate({ ProductTypeId: parseInt(masterform.ProductTypeId.value) },
                        response => {
                            this.form.Rate.value = response.Entities[0].Rate;
                            this.form.Amount.value = this.form.Rate.value * this.form.KnockOff.value;
                        }
                        , { async: false })

                }
            }
            
        }
    }
}